import { messagesInbox as TYPES } from './../action_types';
import _ from 'underscore';

const initialState = {
  models: [],
  meta: {
    cursor: null,
    exhausted: false,
    fetching: false,
    errorFetching: false,
    sending: false,
    sendingError: null,
  },
  replyValue: '',
};

export function MessagesInbox(state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_MESSAGE_THREADS_REQUEST:
      return _.extend({}, state, {
        meta: _.extend({}, state.meta, {
          fetching: true,
        }),
      });

    case TYPES.FETCH_MESSAGE_THREADS_SUCCESS:
      return _.extend({}, state, {
        models: state.models.concat(action.messageThreads),
        meta: _.extend({}, state.meta, {
          fetching: false,
          cursor: action.cursor,
          exhausted: action.exhausted,
          errorFetching: false,
        }),
      });

    case TYPES.MARK_MESSAGE_THREAD_AS_READ:
      var messageThread = _.findWhere(state.models, {
        id: action.messageThread.id,
      });
      var messageThreadIndex = _.indexOf(state.models, messageThread);
      var newMessageThread = _.extend({}, messageThread, {
        messages: _.map(
          _.extend({}, messageThread.messages),
          function (message) {
            return _.extend({}, message, { unread: false });
          },
        ),
        display_message: _.extend({}, messageThread.display_message, {
          unread: false,
        }),
      });
      var models = state.models
        .slice(0, messageThreadIndex)
        .concat(
          [newMessageThread].concat(state.models.slice(messageThreadIndex + 1)),
        );

      return _.extend({}, state, {
        models: models,
      });

    case TYPES.SEND_MESSAGE_REQUEST:
      return _.extend({}, state, {
        meta: _.extend({}, state.meta, {
          sending: true,
          sendingError: null,
        }),
      });

    case TYPES.ADD_MESSAGE_TO_THREAD:
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line @typescript-eslint/no-redeclare
      var messageThread = _.findWhere(state.models, {
        id: action.messageThread.id,
      });
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line @typescript-eslint/no-redeclare
      var messageThreadIndex = _.indexOf(state.models, messageThread);
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line @typescript-eslint/no-redeclare
      var newMessageThread = _.extend({}, messageThread, {
        messages: messageThread.messages.concat(
          action.messageThread.newMessage,
        ),
        display_message: _.extend({}, action.messageThread.newMessage, {
          unread: false,
        }),
        replyValue: '',
      });
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line @typescript-eslint/no-redeclare
      var models = [newMessageThread].concat(
        state.models
          .slice(0, messageThreadIndex)
          .concat(state.models.slice(messageThreadIndex + 1)),
      );

      return _.extend({}, state, {
        models: models,
        meta: _.extend({}, state.meta, {
          sending: false,
        }),
      });

    case TYPES.SEND_MESSAGE_FAILURE:
      return _.extend({}, state, {
        meta: _.extend({}, state.meta, {
          sending: false,
          sendingError: action.error,
        }),
      });

    case TYPES.REMOVE_MESSAGE_THREAD:
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line @typescript-eslint/no-redeclare
      var models = _.reject(state.models, function (messageThread) {
        return messageThread.id === action.messageThread.id;
      });
      return _.extend({}, state, {
        models: models,
      });

    case TYPES.CLEAR_SENDING_ERROR:
      return _.extend({}, state, {
        meta: _.extend({}, state.meta, {
          sending: false,
          sendingError: null,
        }),
      });

    case TYPES.SET_REPLY_VALUE:
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line @typescript-eslint/no-redeclare
      var messageThread = _.findWhere(state.models, {
        id: action.messageThread.id,
      });
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line @typescript-eslint/no-redeclare
      var messageThreadIndex = _.indexOf(state.models, messageThread);
      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line @typescript-eslint/no-redeclare
      var newMessageThread = _.extend({}, messageThread, {
        replyValue: action.messageThread.replyValue,
      });

      // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
      // eslint-disable-next-line @typescript-eslint/no-redeclare
      var models = state.models
        .slice(0, messageThreadIndex)
        .concat(
          [newMessageThread].concat(state.models.slice(messageThreadIndex + 1)),
        );

      return _.extend({}, state, {
        models: models,
      });

    default:
      return state;
  }
}

export default MessagesInbox;
